import { useEffect, useState } from 'react'
import { NVButton } from '@nv/basic-components'
import { useVoterUserContext } from '@nv/contexts'
import CircleArrowLeftIcon from '@nv/images/design/circle-arrow-left-icon'
import CircleArrowRightIcon from '@nv/images/design/circle-arrow-right-icon'
import XIcon from '@nv/images/design/x-icon'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { SideBarItem } from './components/sidebar_item/SideBarItem'
import styles from './SideBar.module.scss'

export const SideBar = ({
  children,
  onClose,
  sayHello = false,
  isMobile = false,
  links,
  logo,
  collapsedLogo,
  isCollapsed: propIsCollapsed,
}: any) => {
  const { t } = useTranslation()
  const VoterUser = sayHello && useVoterUserContext().voterUser

  // Use the passed prop if available
  const [isCollapsed, setIsCollapsed] = useState<boolean>(propIsCollapsed ?? JSON.parse(localStorage.getItem('isCollapsed') || 'false'))

  const toggleCollapse = () => {
    const newState = !isCollapsed
    localStorage.setItem('isCollapsed', JSON.stringify(newState))
    setIsCollapsed(newState)
  }

  useEffect(() => {
    if (propIsCollapsed !== undefined) {
      setIsCollapsed(propIsCollapsed)
    }
  }, [propIsCollapsed])

  return (
    <div
      className={clsx(styles['sidebar'], isMobile ? styles['sidebar__is-mobile'] : styles['sidebar__is-not-mobile'], {
        [styles['sidebar__collapsed']]: isCollapsed,
      })}
    >
      <div className={styles['sidebar__header']}>
        {!isCollapsed ? <span className={styles['sidebar__logo']}>{logo}</span> : collapsedLogo}
        <XIcon onClick={() => onClose()} className={styles['sidebar__x-icon']} />
      </div>

      {sayHello && !isCollapsed && (
        <span>
          {t('main.greeting', {
            name: VoterUser?.fullName || `${VoterUser?.firstName} ${VoterUser?.lastName}`,
          })}
        </span>
      )}
      <div className={styles['sidebar__divider']}></div>
      {links &&
        Object.entries(links).map(([tabkey, tabValue]) => (
          <SideBarItem key={tabkey} tabValue={tabValue} isCollapsed={isCollapsed} isMobile={isMobile} onClose={onClose} />
        ))}
      {children}
      <NVButton
        variant='iconOnly'
        onClick={() => toggleCollapse()}
        icon={isCollapsed ? <CircleArrowRightIcon /> : <CircleArrowLeftIcon />}
        classes={{ container: styles['sidebar__collapse-btn'] }}
        aria-label={t('main.collapseSidebar') + (isCollapsed ? t('main.expand') : t('main.collapse'))}
      />
    </div>
  )
}
